<template>
  <div>
    <suspend :saleStatus="saleStatus"
             :statusInfo="statusInfo"></suspend>
    <div class="big-gift"
         v-if="carInfo&&carInfo.title">
      <div class="title">
        <img class="pc-title"
             src="https://s-test.kcimg.cn/topic/images/shanqi-truck/pc/pc-title1.png"
             alt="">
        <img class="m-title"
             src="https://s-test.kcimg.cn/topic/images/shanqi-truck/m/m-title1.png"
             alt="">
      </div>
      <div class="box">
        <div class="on-sale"
             v-if="saleStatus=='onsale'"></div>
        <a :href="carInfo.link"
           target="_blank"
           class="car-img"
           @click="enterLink($event,carInfo.link)">
          <img :src="carInfo.img"
               alt="">
          <!--有库存，当前时间已到开抢时间不显示蒙层-->
          <div class="model"
               v-if="saleStatus!='load'&&saleStatus!=='onsale'">
            <!--有库存，当前时间未到开抢时间-->
            <i v-if="saleStatus=='will'"
               class="will"></i>
            <p v-if="saleStatus=='will'"
               class="will-word">抢3000元优惠，10:00点开抢</p>
            <!--无库存，当前时间已到开抢时间-->
            <i v-if="saleStatus=='sale'"
               class="sale"></i>
            <p v-if="saleStatus=='sale'">今日已抢光，明日10点再来吧</p>
            <!--活动时间已结束-->
            <i v-if="saleStatus=='stop'"
               class="stop"></i>
            <!--无库存，当前时间未到开抢时间-->
            <i v-if="saleStatus=='new'"
               class="new"></i>
            <p v-if="saleStatus=='new'">库存上新中，每天10点开抢</p>
          </div>
        </a>
        <div class="info">
          <h5>{{carInfo.title}}</h5>
          <div class="prize"
               v-html="carInfo.price"></div>
          <p :class="!carInfo.desc?'no-desc':''">{{carInfo.desc}}</p>
          <a :href="carInfo.link"
             target="_blank"
             class="btn"
             v-html="carInfo.save"
             @click="enterLink($event,carInfo.link)">
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import XHR from '../api'
import Suspend from '../components/Suspend'
export default {
  name: 'BigGift',
  props: [],
  data: () => ({
    // 手工位展示信息
    carInfo: {},
    // 当前时间
    now: 0,
    // 抢购倒计时相关信息
    statusInfo: {}
  }),
  components: {
    Suspend
  },
  computed: {
    saleStatus () {
      if (!this.statusInfo.status) {
        return 'load'
      } else {
        switch (this.statusInfo.status) {
          case 1:
            if (this.statusInfo.stocknum !== '0') {
              return 'will'
            } else {
              return 'new'
            }
          case 3:
            if (this.statusInfo.stocknum !== '0') {
              return 'onsale'
            } else {
              return 'sale'
            }
          case 4:
            return 'stop'
          default:
            return 'onsale'
        }
      }
    }
  },
  created () {
    XHR.getHandWork({
      type: 18,
      hid: 3840
    }).then(res => {
      const { status, data } = res.data
      if (!status) {
        this.carInfo = data[0]
        this.getStatus(data[0].activity)
      }
    }).catch(err => {
      console.log(err)
    })
  },
  mounted () { },
  methods: {
    enterLink (ev, link) {
      ev.preventDefault()
      this.sendAnalytics('陕汽德龙X3000专题活动', '复工领壕礼-点击优惠', this.carInfo.title)
      window.location.href = link
    },
    getStatus (id) {
      XHR.getCarStatus({
        id: id
      }).then(res => {
        const { status, data } = res.data
        if (!status) {
          this.statusInfo = data
          this.now = data.timestamp
        }
      }).catch(err => {
        console.log(err)
      })
    }
  }
}
</script>
<style lang="less">
.big-gift .info .btn em {
  font-weight: bold;
  font-size: 44px;
}

.prize {
  em {
    color: #f5cd94;
    font-weight: bold;
    font-size: 40px;
  }
}
</style>
<style lang="less" scoped>
.big-gift {
  margin-top: 78px;
}
.title {
  .pc-title {
    display: none;
  }
  .m-title {
    margin: 0 auto;
    display: block;
    width: 300px;
  }
}
.box {
  margin: 0 auto;
  background-size: cover;
  background-image: url("https://s-test.kcimg.cn/topic/images/shanqi-truck/m/m-box1.png");
  width: 620px;
  height: 731px;
  position: relative;
  padding: 60px 40px 38px 40px;
  box-sizing: border-box;
  .on-sale {
    background: url("https://s-test.kcimg.cn/topic/images/shanqi-truck/m/m-hot-buy.png");
    width: 257px;
    height: 78px;
    position: absolute;
    top: 59px;
    left: -8px;
    z-index: 10;
  }
  .car-img {
    width: 536px;
    height: 356px;
    border: 4px solid #f5cd94;
    position: relative;
    cursor: pointer;
    display: inline-block;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    .model {
      background-color: rgba(0, 0, 0, 0.8);
      opacity: 0.8;
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      i {
        width: 220px;
        height: 150px;
      }
      .stop {
        background-image: url("https://s-test.kcimg.cn/topic/images/shanqi-truck/m/m-stop-stamp.png");
      }
      .will {
        background-image: url("https://s-test.kcimg.cn/topic/images/shanqi-truck/m/m-will-stamp.png");
      }
      .will-word {
        color: #f5cd94;
      }
      .new {
        background-image: url("https://s-test.kcimg.cn/topic/images/shanqi-truck/m/m-new-stamp.png");
      }
      .sale {
        background-image: url("https://s-test.kcimg.cn/topic/images/shanqi-truck/m/m-sale-stamp.png");
      }
      p {
        font-size: 24px;
        color: #ffffff;
        margin-top: 16px;
      }
    }
  }
  .info {
    h5 {
      color: #fffefe;
      font-size: 36px;
      font-weight: bold;
      margin-top: 26px;
    }
    .prize {
      color: #ffffff;
      font-size: 28px;
      line-height: 40px;
    }
    p {
      display: inline-block;
      font-size: 24px;
      color: #f5cd94;
      border-radius: 5px;
      border: 1px solid #f5cd94;
      padding: 0 6px;
      margin: 10px 0;
      &.no-desc {
        border: none;
        height: 38px;
        display: inherit;
      }
    }
    .btn {
      cursor: pointer;
      margin-top: 5px;
      background: url("https://s-test.kcimg.cn/topic/images/shanqi-truck/m/m-buy.png");
      width: 558px;
      height: 98px;
      line-height: 78px;
      font-size: 28px;
      color: rgb(245, 205, 148);
      text-align: center;
      margin-left: -10px;
      display: inline-block;
      &.disabled {
        background: url("https://s-test.kcimg.cn/topic/images/shanqi-truck/m/m-buy-disabled.png");
      }
    }
  }
}
@media screen and (min-width: 751px) {
  .title {
    .pc-title {
      margin: 0 auto;
      display: block;
      width: 380px;
    }
    .m-title {
      display: none;
    }
  }
  .box {
    background-image: url("https://s-test.kcimg.cn/topic/images/shanqi-truck/pc/pc-box1.png");
    width: 1000px;
    height: 367px;
    display: flex;
    .on-sale {
      background: url("https://s-test.kcimg.cn/topic/images/shanqi-truck/pc/pc-hot-buy.png");
      width: 185px;
      height: 68px;
      position: absolute;
      top: 59px;
      left: -8px;
    }
    .car-img {
      width: 394px;
      height: 263px;
      .model {
        i {
          width: 179px;
          height: 120px;
          background-size: cover;
        }
        .will {
          background-image: url("https://s-test.kcimg.cn/topic/images/shanqi-truck/pc/pc-will-stamp.png");
        }
        .sale {
          background-image: url("https://s-test.kcimg.cn/topic/images/shanqi-truck/pc/pc-sale-stamp.png");
        }
        .stop {
          background-image: url("https://s-test.kcimg.cn/topic/images/shanqi-truck/pc/pc-stop-stamp.png");
        }
        .new {
          background-image: url("https://s-test.kcimg.cn/topic/images/shanqi-truck/pc/pc-new-stamp.png");
        }
        p {
          font-size: 16px;
          margin-top: 20px;
        }
      }
    }
    .info {
      margin-left: 20px;
      h5 {
        margin-top: 0;
      }
      .prize {
        margin-top: 10px;
      }
      .btn {
        background: url("https://s-test.kcimg.cn/topic/images/shanqi-truck/pc/pc-buy.png");
        width: 418px;
        height: 98px;
        margin-left: -9px;
        margin-top: 20px;
        &.disabled {
          background: url("https://s-test.kcimg.cn/topic/images/shanqi-truck/pc/pc-buy-disabled.png");
        }
      }
    }
  }
}
</style>
